import { api } from "./api";

const PLAN_PENDIENTE_KEY = "pd_plan_pendiente";
const PLANES_VALIDOS = ["plus", "pro", "max"] as const;
type PlanValido = (typeof PLANES_VALIDOS)[number];

function esPlanValido(p: string | null): p is PlanValido {
  return !!p && (PLANES_VALIDOS as readonly string[]).includes(p);
}

/**
 * Si hay un plan de pago pendiente guardado en localStorage (ver Registro.tsx),
 * crea la sesión de Stripe y redirige al checkout. Si no hay nada pendiente o
 * Stripe falla, no hace nada y deja que el caller decida a dónde navegar.
 * Devuelve true si la navegación a Stripe ya se disparó.
 */
export async function continuarConPlanPendiente(token: string): Promise<boolean> {
  const planPendiente = localStorage.getItem(PLAN_PENDIENTE_KEY);
  localStorage.removeItem(PLAN_PENDIENTE_KEY);

  if (esPlanValido(planPendiente)) {
    const res = await api.crearSesionPago(token, planPendiente);
    if (res.ok) {
      window.location.href = res.data.url;
      return true;
    }
  }
  return false;
}

export { PLAN_PENDIENTE_KEY };
